/**
 * One name per message (S8-19, 07/U12). Every screen, template header and summary text that names a summary uses these —
 * never a hand-typed "סיכום יומי" / "סיכום מנהל" / "בוקר טוב".
 */
export const SUMMARY_NAMES = {
  daily: { he: 'תדריך בוקר', en: 'Morning brief' },
  weekly: { he: 'דוח צוות שבועי', en: 'Weekly team report' },
  /** the callback list: who to call back today */
  morning: { he: 'למי חוזרים היום', en: 'Who to call back today' },
  /** a parent account's ("לקוח-על") daily / weekly */
  networkDaily: { he: 'תדריך רשת', en: 'Network brief' },
  networkWeekly: { he: 'דוח רשת שבועי', en: 'Weekly network report' },
} as const;

export type SummaryNameKey = keyof typeof SUMMARY_NAMES;

/** Route purposes (what a recipient gets) in Hebrew. "סיכומים" stays the umbrella tab name. */
export const PURPOSE_NAMES: Record<'alerts' | 'daily_summary' | 'weekly_summary' | 'morning_summary' | 'general', string> = {
  alerts: 'התראות',
  daily_summary: SUMMARY_NAMES.daily.he,
  weekly_summary: SUMMARY_NAMES.weekly.he,
  morning_summary: SUMMARY_NAMES.morning.he,
  general: 'הודעות כלליות',
};
